import React from 'react';
import {
  BusinessCenterIcon,
  ContentPasteIcon,
  DiplomaIcon,
  PsychologyIcon,
  SchoolIcon,
} from '../icons';

const categories = [
  {
    id: '1',
    icon: PsychologyIcon,
    name: 'THE CARRERAS SEEK SCHOLARSHIP',
    description:
      'is the premium scholarship category of the Carreras Scholarship programme as it offers up to one million dollars (JA$1 million) to each successful applicant. The scholarship is awarded to students pursuing studies in Liberal Arts, Humanities and Sciences.',
  },
  {
    id: '2',
    icon: SchoolIcon,
    name: 'The CARRERAS COMMUNITY COLLEGES SCHOLARSHIP',
    description:
      "as the name suggests, is offered to students of Community Colleges such as the Excelsior Community College, Knox Community College, Portmore Community College, College of Agriculture, Science, and Education (CASE), Brown's Town Community College, Montego Bay Community College, Moneague Community College and Bethlehem-Moravian College. Each scholarship is worth up to one hundred thousand dollars (JA$100,000).",
  },
  {
    id: '3',
    icon: DiplomaIcon,
    name: "THE CARRERAS TEACHERS' COLLEGES SCHOLARSHIP",
    description:
      "is also valued at up to one hundred thousand dollars (JA$100,000). It is open to teachers in training at numerous colleges across the island namely Church Teachers' College, Mico University College, Sam Sharpe Teachers' College, Shortwood Teachers' College and St. Joseph's Teachers' College.",
  },
  {
    id: '4',
    icon: ContentPasteIcon,
    name: 'The CARRERAS VISUAL AND PERFORMING ARTS SCHOLARSHIP',
    description:
      'category solely targets students of the Edna Manley College of the Visual and Performing Arts. Each awardee receives up to one hundred thousand dollars (JA$100,000).',
  },
  {
    id: '5',
    icon: BusinessCenterIcon,
    name: 'CARRERAS UNIVERSITY BURSARY',
    description:
      'is offered to students of The University of the West Indies (UWI), University of Technology, Jamaica (UTECH), Northern Caribbean University (NCU), University of the Commonwealth Caribbean (UCC), Hydel College and the Caribbean Maritime University. If awarded, each student receives from JA$50,000 to JA$100,000',
  },
];

export default function Categories() {
  return (
    <div className="mt-8 lg:mt-24 flex flex-col p-4 lg:px-20 lg:py-8">
      <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-8">
        {categories.map((category) => (
          <div key={category.id} className="relative">
            <dt>
              <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-magenta text-white">
                <category.icon className="h-6 w-6" aria-hidden="true" />
              </div>
              <p className="ml-16 text-lg leading-6 font-medium text-gray-900">
                {category.name}
              </p>
            </dt>
            <dd className="mt-2 ml-16 text-base text-gray-500 text-justify">
              {category.description}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
